import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,
    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator,
    Text,
    PermissionsAndroid,
    Linking, I18nManager,
    Image, Clipboard
} from "react-native";


import {scale, moderateScale, verticalScale} from '../../../../tools/Scaling';


// import HMActionBarSatia from "../../customviews/HMActionBarSatia";


import i18n from '../../../../I18n/i18n.js';
//import HMImageBackground from "../../customviews/HMImageBackground";

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";


// import HMLoading from "../../customviews/HMLoading";

import store from "../../../../redux/store";
import {connect} from "react-redux";
import axios from "axios";
import {
    serviceActionAccount,
    serviceActionSuccess
} from "../../../../screens/satia/splash/action/ActionSplashSatiaScreen";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import {typeExport} from "../../../../redux/store/type";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMListCheckBox from "../../../../customviews/HMListCheckBox";
import {Tools} from "../../../../tools/Tools";
import HMIcon from "../../../../customviews/HMIcon";
import HMImageView from "../../../../customviews/HMImageView";
import Toast from "../../../../customviews/toast";
import {isMobile} from "react-device-detect";

let container = null

class IntroduceFriendsSatiaScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            indexSelectType: 0,
            // list: [],
            list: props.route && props.route.params && props.route.params.list ? props.route.params.list : (this.props.user && this.props.user.customers ? this.props.user.customers : []),
            DescriptionSelectCheckBoxIntroduceFriends: null,
            indexSelectCheckBoxIntroduceFriends: null,
            /*    list: [
                    {
                        Serial: 1,
                        Name: 'رایانکده آپادانا',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 2,
                        Name: 'وحید قایم مقامی',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 3,
                        Name: 'وحید قایم مقامی',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 4,
                        Name: 'دانشکده علوم پزشکی نهاوند',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 5,
                        Name: 'وحید قایم مقامی',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 6,
                        Name: 'ساتیا',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 7,
                        Name: 'وحید قایم مقامی',
                        Type: 'ADSL',

                    },


                ],*/
            listFilter: []
        };

        // props.callServiceRefresh();


    }

    componentDidMount() {

        // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        //this.getData()

    }


    /*  getData() {

          this.setState({
              //ShowImage:true
              isLoading: true,
              NoInternetDialog: false,

          })


          const formData = new FormData();
          formData.append('lang', i18n.locale);
          formData.append('token', this.props.token);


          const config = {
              headers: {
                  "Content-Type": "multipart/form-data; charset=utf-8;",
                  // 'Content-Type': 'application/json',
                  // "Authorization": `Basic ${params.token}`,
                  timeout: Constants._TIMEOUT_FILE
              }
          };

          axios.post(typeExport._baseUrlSatia + "services/customerGigs", formData, config)
              .then(async response => {
                  let data = response.data;
                  let list = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;


                  // data.status ? this.state.listImage.push(image) : null;

                  this.setState({
                      //ShowImage:true
                      list: data.status ? list : this.state.list,
                      //TypeDocumentsList:[],
                      isLoading: false,
                      NoInternetDialog: !data.status,

                  })
              }).catch((e) => {

              this.setState({
                  //ShowImage:true
                  isLoading: false,
                  NoInternetDialog: true,

              })
          })
      }*/

    render() {
        // let {} = this.props.route.params
        let item = this.props.route.params ? this.props.route.params.item : null

        let account = this.props.DataSplashSatiaScreen.Account;
        let info = this.props.DataSplashSatiaScreen.results.info;
        let url = info.linkIntroduceFriends + account.Serial;

        return (
            <View style={{position: 'relative', flex: 1}}>


                {/*     <HMImageBackground

                />*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBarSatia
                            menu={account}
                            back={account}
                            props={this.props} statusBarTransparent
                          //  text={"معرفی به دوستان"}
                             text={item ? (item.name ? item.name : (item.title ? item.title : '')) : "معرفی به دوستان"}
                            //   text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            LeftView={
                                Platform.OS === "web" && !(isMobile) ?
                                    null
                                    :
                                    <TouchableOpacity
                                        style={{
                                            //   backgroundColor: Colors.red,
                                            //    marginHorizontal: moderateScale(10),
                                            width: moderateScale(24),
                                            height: moderateScale(48),

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}

                                        onPress={

                                            //  onBackPress
                                            () => {
                                                Tools.onShare(item);

                                            }
                                        }
                                    >
                                        <HMIcon name={"ios-share-social-outline"}
                                                style={{fontSize: moderateScale(26), color: Colors.white}}/>


                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </TouchableOpacity>

                            }

                        />

                        {/*
                        <View style={{flex: 1}}>

                            <HMTextView
                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                text={`${info.introduceFriendsCost} تومان اعتبار هدیه!\n` +
                                "با دعوت از دوستانتان برای پیوستن به خانواده ساتیا،" +
                                ` شما ${info.introduceFriendsCost} تومان اعتبار هدیه می‌گیرید!`}
                                type={"bold"}
                                style={{
                                    //  textAlign: "center",
                                    color: Colors.colorDarkText,
                                    fontSize: moderateScale(12),
                                    marginTop: moderateScale(20),
                                    marginHorizontal: moderateScale(10),

                                }}/>
                            <View>
                                <HMListCheckBox
                                    data={{
                                        list: [
                                            {
                                                id: 1,
                                                //  name: i18n.t('constant.Injury')
                                                name: "خودم ثبت نام می کنم",
                                                description: `اکانت ${account.AdslTel} بعد از معرفی ${info.introduceFriendsCost} هزار تومان شارژ می شود اگر مایل هستید کلیک نمایید`,
                                            },
                                            {
                                                id: 2,
                                                name: "ثبت نام با لینک",
                                                description: `اکانت ${account.AdslTel} بعد از معرفی ${info.introduceFriendsCost} هزار تومان شارژ می شود اگر مایل هستید کلیک نمایید` + `  لینک معرفی ${info.linkIntroduceFriends + account.Serial} `,

                                            },

                                        ],

                                        indexSelect: this.state['indexSelectCheckBoxIntroduceFriends'],
                                        name: 'IntroduceFriends',

                                    }}
                                    onPress={this.onPressSelectCheckBox
                                    }

                                />
                            </View>
                            {
                                this.state.DescriptionSelectCheckBoxIntroduceFriends ?
                                    <TouchableOpacity

                                        onPress={() => {
                                            if (this.state.indexSelectCheckBoxIntroduceFriends == 1) {
                                                NavigationService.navigateParams("InformationSatiaScreen")

                                            }
                                            else {
                                               // Tools.GoLink(info.linkIntroduceFriends + account.Serial, "self")
                                                Tools.onShare({link_url:info.linkIntroduceFriends + account.Serial});

                                            }
                                            // refs['viewPager'].setPage(state.currentPage - 1);
                                            //refs['viewPager'].setPage(state.currentPage - 1);

                                            //  goBack();
                                        }}
                                        style={{
                                            width: "98%",
                                           // height: moderateScale(42),
                                            margin: moderateScale(8),
                                            alignSelf: 'center',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: Colors.white,
                                            borderRadius: moderateScale(6),
                                            borderColor: Colors.colorPrimary,
                                            borderWidth: moderateScale(2),

                                        }}>

                                        <HMTextView
                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                            text={this.state.DescriptionSelectCheckBoxIntroduceFriends} type={"bold"}
                                            style={{
                                                fontSize: moderateScale(13),
                                                marginVertical: moderateScale(6),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.colorPrimary
                                            }}/>
                                    </TouchableOpacity>
                                    :
                                    null

                            }


                        </View>

                        */}
                        <ScrollView>
                            <View
                                style={{
                                    flex: 1,
                                    margin: moderateScale(10),
                                    backgroundColor: Colors.white,
                                    borderRadius: moderateScale(8),
                                    padding: moderateScale(10)
                                }}>

                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <HMTextView

                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={info.introduceFriends.title} type={"bold"}
                                        style={{
                                            fontSize: moderateScale(16),
                                            marginVertical: moderateScale(6),
                                            marginHorizontal: moderateScale(4),
                                            color: Colors.colorPrimary
                                        }}/>
                                    <View style={{width: moderateScale(16)}}/>
                                    <View style={{width: moderateScale(150), height: moderateScale(150 / 2.24)}}>
                                        <HMImageView
                                            _backgroundColorLoading={Colors.transparent}
                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                            uriComplete={info.introduceFriends.titleImage}
                                            styleText={{marginTop: moderateScale(10)}} borderRadius={4}
                                        />
                                    </View>
                                    {/*  <HMTextView

                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                        text={`وحید  عزیز سلام`} type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.colorPrimary
                                    }}/>*/}


                                </View>
                                <HMTextView
                                    text={info.introduceFriends.titleDescription}
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    //                                     text={`وحید عزیز سلام
                                    // ساتیا در جشنواره پاییزه به شما و دوستانی که شما معرفی می کنید  ${info.introduceFriendsCost+info.introduceFriendsCostNew} هزار تومان تخفیف ویژه می دهد. در این طرح مشارکت کنید و دوستانتان را خوشحال کنید. شما به دو روش، می توانید از کارت تخفیف دوقلو بهرمند شوید
                                    //  1- ارسال تبلیغ به دوستان
                                    //  2- ثبت نام آنلاین دوستان`}
                                    //
                                    type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.colorDarkText
                                    }}/>

                                {/*

                                <HMTextView

                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={`    1- می توانید متن پیام تبلیغی ذیل را به همراه لینک اختصاصی خودتان در گروههای خانوادگی ارسال کنید و هر کس از طریق این لینک ها ثبت نام کند اشتراک شما مبلغ ${info.introduceFriendsCost} هزار تومان شارژ می شود و به دوست شما هم پیام می دهیم که شما برنده تخفیف ${info.introduceFriendsCostNew} هزار تومانی شده اید، چون معرف شما جناب ..${account.Name}.. می باشد`}
                                    type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.colorDarkText
                                    }}/>
*/}

                                {
                                    info.introduceFriends.link ?
                                        <TouchableOpacity
                                            style={{
                                                width: "100%",
                                                margin: moderateScale(2),
                                                backgroundColor: "#f2f2f2",
                                                borderRadius: moderateScale(8),
                                                padding: moderateScale(10)
                                            }}
                                            onPress={()=>{
                                                NavigationService.navigateParams("IntroduceFriendsChildSatiaScreen",null)
                                            }}

                                        >

                                            <View
                                                style={[{
                                                    flexDirection: 'row',
                                                    //  //justifyContent: "flex-end",
                                                    //alignItems: "flex-start",
                                                    // width: '94%',
                                                    height: moderateScale(48),
                                                    // margin: moderateScale(4),
                                                    //  alignSelf: 'center',
                                                    marginHorizontal: moderateScale(10), alignItems: 'center'
                                                }]}
                                            >
                                                <HMIcon name={"send"}
                                                        type={"Feather"}
                                                        style={{
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.blackLight,
                                                            width: moderateScale(29),
                                                            height: moderateScale(29),
                                                            fontSize: moderateScale(24)
                                                        }}/>
                                                <View style={{width: moderateScale(4)}}/>
                                                <HMTextView
                                                    text={info.introduceFriends.suggestionTitle}
                                                    type={"bold"}
                                                    style={{
                                                        alignSelf: 'center',
                                                        //  marginRight: moderateScale(6),
                                                        // margin: moderateScale(6),
                                                        textAlign: 'center',
                                                        color: Colors.blue,
                                                        fontSize: moderateScale(14),
                                                    }}/>
                                            </View>
                                            <HMTextView
                                                text={info.introduceFriends.suggestionDescription}
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                //                                         text={`سلام
                                                // من قبلا با سرعت اینترنت مشکل داشتم و از وقتی ساتیا خریدم مشکلم حل شد و راضی هستم اگر با سرعت یا قیمت اینترنت خودتان مشکل دارید فروش ویژه پائیزه ساتیا بنام انار نت را امتحان کنید
                                                // انارنت با 1500 گیگابایت تقریبا نامحدود هست و سرعت 8 تا 16 مگابیت دارد و با قیمت 90 هزار تومان ارائه می شود
                                                // ساتیا بدلیل اینکه من معرف شما هستم 30 هزار تومان تخفیف ویژه به شما  خواهد داد
                                                // اگر دوست داشتید روی این لینک کلیک کنید و شماره خودتان را وارد کنید تا با شما تماس بگیرند
                                                // `}

                                                type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.colorDarkText
                                                }}/>


                                        </TouchableOpacity>
                                        :
                                        null
                                }

                                <TouchableOpacity
                                    style={{
                                        width: "100%",
                                        margin: moderateScale(2),
                                        backgroundColor: "#f2f2f2",
                                        borderRadius: moderateScale(8),
                                        padding: moderateScale(10)
                                    }}
                                    onPress={() => {
                                        if (Platform.OS === "web")
                                            NavigationService.navigateParams("InformationSatiaScreen")
                                        else
                                            Tools.GoLink(url)

                                    }
                                    }

                                >


                                    <View
                                        style={[{
                                            flexDirection: 'row',
                                            //  //justifyContent: "flex-end",
                                            //alignItems: "flex-start",
                                            // width: '94%',
                                            height: moderateScale(48),
                                            // margin: moderateScale(4),
                                            //  alignSelf: 'center',
                                            marginHorizontal: moderateScale(10), alignItems: 'center'
                                        }]}
                                    >
                                        <HMIcon name={"md-cart-outline"}
                                               // type={"FontAwesome"}
                                                style={{
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.blackLight,
                                                    width: moderateScale(29),
                                                    height: moderateScale(29),
                                                    fontSize: moderateScale(24)
                                                }}/>
                                        <View style={{width: moderateScale(4)}}/>
                                        <HMTextView
                                            text={info.introduceFriends.straightTitle}
                                            type={"bold"}
                                            style={{
                                            alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            textAlign: 'center',
                                            color: Colors.blue,
                                            fontSize: moderateScale(14),
                                        }}/>
                                    </View>
                                    <HMTextView

                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                       // text={`  از این گزینه می توانید مستقیم برای دوستان خود سرویس خریداری کنید و بعد از پرداخت هزینه سرویس و تکمیل خرید هدیه به اشتراک شما اضافه می شود`}
                                        text={info.introduceFriends.straightDescription}
                                        type={"bold"}
                                        style={{
                                            fontSize: moderateScale(13),
                                            marginVertical: moderateScale(6),
                                            marginHorizontal: moderateScale(4),
                                            color: Colors.colorDarkText
                                        }}/>

                                </TouchableOpacity>
                            </View>
                        </ScrollView>
                    </KeyboardAvoidingView>
                </View>


            </View>
        );
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
                ['DescriptionSelectCheckBox' + name]: (item.description)
            },
            () => {
            })
    }

}

const mapStateToProps = state => {
    return {

        user: state.reducerSplashSatiaScreen.user,
        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(IntroduceFriendsSatiaScreen);
